export const COUPON_PERIOD_MAX_SECONDS = 2147483647;

export type CouponPeriodUnit = "years" | "months" | "days";

export const COUPON_PERIOD_SECONDS: Record<CouponPeriodUnit, number> = {
  years: 31557600,
  months: 2629800,
  days: 86400,
};

export const COUPON_PERIOD_UNIT_LABELS: Record<CouponPeriodUnit, string> = {
  years: "년",
  months: "개월",
  days: "일",
};

export const toCouponPeriodSeconds = (
  period: string | number,
  unit: CouponPeriodUnit,
): number | null => {
  const numericPeriod = Number(period);
  if (!Number.isFinite(numericPeriod)) {
    return null;
  }

  const periodSeconds = numericPeriod * COUPON_PERIOD_SECONDS[unit];
  if (periodSeconds > COUPON_PERIOD_MAX_SECONDS) {
    return null;
  }

  return periodSeconds;
};

export const getCouponPeriodLimitMessage = (unit: CouponPeriodUnit): string => {
  const maxPeriod = Math.floor(COUPON_PERIOD_MAX_SECONDS / COUPON_PERIOD_SECONDS[unit]);
  const label = COUPON_PERIOD_UNIT_LABELS[unit];

  return `유효기간은 ${maxPeriod}${label} 이하로 입력해주세요. 날짜지정 방식도 사용할 수 있습니다.`;
};
